import { useCallback, useMemo, useState } from 'react';

export type UseBranchMultiSelect = {
	selectedIds: string[];
	toggleId: (id: string) => void;
	selectAll: () => void;
	clearAll: () => void;
	isSelected: (id: string) => boolean;
	allSelected: boolean;
};

export function useBranchMultiSelect(
	availableIds: string[],
	defaultIds: string[] = [],
) {
	const [selectedIds, setSelectedIds] = useState<string[]>(defaultIds);

	const toggleId = useCallback((id: string) => {
		setSelectedIds((prev) =>
			prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
		);
	}, []);

	const selectAll = useCallback(() => {
		setSelectedIds(availableIds);
	}, [availableIds]);

	const reset = useCallback((originalIds: string[] = []) => {
		setSelectedIds(originalIds);
	}, []);

	const isSelected = useCallback(
		(id: string) => selectedIds.includes(id),
		[selectedIds],
	);

	const allSelected = useMemo(() => {
		return (
			availableIds.length > 0 &&
			availableIds.every((id) => selectedIds.includes(id))
		);
	}, [availableIds, selectedIds]);

	return {
		selectedIds,
		toggleId,
		selectAll,
		reset,
		isSelected,
		allSelected,
	};
}
